import { Component, input, output } from '@angular/core';
import { IconComponent } from '@sirius/common';

import { ITaxonomyOption } from '../../domain/recommendations';

@Component({
    selector: 'robot-selector-taxonomy-select',
    templateUrl: './taxonomy-select.component.html',
    styleUrl: './taxonomy-select.component.scss',
    imports: [IconComponent],
    host: {
        'class': 'taxonomy-select',
    },
})
export class TaxonomySelectComponent {
    readonly label = input.required<string>();

    readonly optionalSuffix = input.required<string>();

    readonly noSelectionLabel = input.required<string>();

    readonly options = input.required<readonly ITaxonomyOption[]>();
    readonly value = input<string | null>(null);

    readonly valueChange = output<string | null>();

    onChange(event: Event): void {
        const raw = (event.target as HTMLSelectElement).value;
        this.valueChange.emit(raw === '' ? null : raw);
    }
}
